import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-text-box',
  templateUrl: './text-box.component.html',
  styleUrls: ['./text-box.component.scss']
})
export class TextBoxComponent implements OnInit {

  constructor() { }
  @Output() addItemEvent = new EventEmitter<string>();
  newItem: string = '';

  addItem(): void {
    if (this.newItem.trim() !== '') {
      this.addItemEvent.emit(this.newItem);
      this.newItem = '';
    }
  }

  clearItems(): void {
    this.newItem = '';
  }
  ngOnInit(): void {
  }

}
